import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DataGrid } from '@mui/x-data-grid';
import { toast } from 'react-toastify';
import { getAppointmentStat } from '../../../api/approvalsApi';

export default function AppointmentStatTable({ approvalId, date, repId, dateSubmitted }) {
  const [tableData, setTableData] = useState({
    data: [],
    totalRows: 0,
    loading: false,
  });

  const columns = useMemo(
    () => [
      {
        field: 'name',
        headerName: 'MD Name',
        flex: 1,
        minWidth: 300,
      },
      {
        field: 'target_calls',
        headerName: 'Target Calls',
        flex: 1,
        type: 'number',
      },
      {
        field: 'for_approval',
        headerName: 'Call For Approval',
        flex: 1,
        type: 'number',
      },
      {
        field: 'approved',
        headerName: 'Approved',
        flex: 1,
        type: 'number',
      },
      {
        field: 'total',
        headerName: 'Total',
        flex: 1,
        type: 'number',
        renderCell: ({ row }) => `${row.total}%`,
      },
    ],
    [],
  );

  const loadData = async () => {
    try {
      setTableData({ ...tableData, data: [], loading: true });
      const res = await getAppointmentStat({
        rep_id: repId,
        approval_id: approvalId,
        date,
        date_submitted: dateSubmitted,
      });

      const { success, totalRows, data, message } = res.data;

      setTableData({ ...tableData, loading: false });

      if (!success) {
        toast.error(message);
        return;
      }

      setTableData({
        ...tableData,
        data,
        totalRows,
      });
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    if (repId && dateSubmitted) {
      loadData();
    }
  }, [approvalId, date, repId, dateSubmitted]);

  return (
    <div style={{ height: '550px' }}>
      <DataGrid
        rows={tableData.data}
        rowCount={tableData.totalRows}
        columns={columns}
        pageSize={50}
        loading={tableData.loading}
        disableSelectionOnClick
      />
    </div>
  );
}

AppointmentStatTable.propTypes = {
  approvalId: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  repId: PropTypes.string.isRequired,
  dateSubmitted: PropTypes.string.isRequired,
};
